__turbopack_context__.v({
  "SkeletonGroup": "RenderLoadingReview-module-scss-module__P0Idoa__SkeletonGroup",
});
